export default __webpack_public_path__ + "static/Stickers-joinsticker-96aebe8f0f4c814cf7889602c1e93b78.png";